<div class="smooth-scrolling">
  <div class="blog-search-bar-new">
    <div class="row">
      <div class="col-12 d-lg-none d-flex leftSide">
        <div class="bl-search" [formGroup]="blogSearchForm">
          <div class="search-inputbox" (click)="clickSearch()">
            <input type="search" placeholder="Search blog" name="blog-search" id="blog-search" formControlName="search">
            <div class="search-btn"><input type="submit"><img src="assets/images/search-icon-dark.svg" /></div>
          </div>
          <div [ngClass]="show ? 'open-search-bar':''">
            <ul class="scrollbar" *ngIf="mblogResponse && mblogResponse?.data && mblogResponse.data[0]?.id && show; else noData">
              <li *ngFor="let blogList of mblogResponse?.data">
                <span class="search-icon-new"><img src="assets/images/search-black-nav.svg" alt="icon"></span>
                <a (click)="openBlogDetail(blogList)">{{blogList?.title}}</a></li>
            </ul>

            <ng-template #noData>
              <ul *ngIf="show" class="no-data-h">
                <li>
                  <span class="search-icon-new"><img src="assets/images/search-black-nav.svg" alt="icon"></span>
                  <small>No Data Found</small>
                </li>
              </ul>
            </ng-template>
          </div>
          <div [ngClass]="historyShow ? 'open-search-bar':''">
            <ul class="scrollbar" *ngIf="historyShow && arrSearchHistory && arrSearchHistory.length>0">
              <li class="bold">History</li>
              <li *ngFor="let history of arrSearchHistory">
                <span class="search-icon-new"><img src="assets/images/search-history-icon.png" alt="icon"></span>
                <a (click)="openBlogDetail(history)">{{history.title}}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

    <!-- blog-filter-panel START -->
  <section class="blog-filter-panel mb-3 d-none d-lg-flex">
    <div class="row align-items-center justify-content-between w-100" >
      <div class="col-lg-3 d-lg-flex d-none leftSide">
        <div class="bl-search" [formGroup]="blogSearchForm">
          <div class="search-inputbox" (click)="clickSearch()">
            <input type="search" placeholder="Search blog" name="blog-search" id="blog-search" formControlName="search">
            <div class="search-btn"><input type="submit"><img src="assets/images/search-icon-dark.svg" /></div>
          </div>
          <div [ngClass]="show ? 'open-search-bar':''">
            <ul class="scrollbar" *ngIf="mblogResponse && mblogResponse?.data && mblogResponse.data[0]?.id; else noData">
              <li *ngFor="let blogList of mblogResponse?.data">
                <span class="search-icon-new"><img src="assets/images/search-black-nav.svg" alt="icon"></span>
                <a (click)="openBlogDetailSearch(blogList)">{{blogList?.title}}</a></li>
            </ul>

            <ng-template #noData>
              <ul *ngIf="show" class="no-data-h">
                <li>
                  <span class="search-icon-new"><img src="assets/images/search-black-nav.svg" alt="icon"></span>
                  <small>No Data Found</small></li>
              </ul>
            </ng-template>
          </div>
          <div [ngClass]="historyShow ? 'open-search-bar':''">
            <ul class="scrollbar" *ngIf="historyShow && arrSearchHistory && arrSearchHistory.length>0">
              <li class="bold">History</li>
              <li *ngFor="let history of arrSearchHistory">
                <span class="search-icon-new"><img src="assets/images/search-history-icon.png" alt="icon"></span>
                <a (click)="openBlogDetail(history)">{{history.title}}</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-8 rightSide">
        <div>
            <ul class="skin-type-c scrollbar scrollbar-none">
                <li *ngFor="let cat of mCategoryResponseModal.data; let i = index" (click)="openBlogList(cat.id)"><a >{{cat?.name}}</a></li>
            </ul>
        </div>
    </div>
    </div>
  </section>

  <div class="top-breadcrunbs mt-lg-4 mt-0">
    <ul>
      <li><a (click)="openBlogViaSubCategory()"><img src="assets/images/back-arrow.svg" alt=""></a></li>
      <li class="breadcrumb-item"><a (click)="gotToBlog()">Blogs</a></li>
      <li class="breadcrumb-item" aria-current="page" *ngIf="blogDetail?.category?.id">
        <a (click)="openBlogViaCategory()">
          {{ blogDetail?.category?.name?.length ?? 0 > 15 ? (blogDetail?.category?.name | slice:0:15) : blogDetail?.category?.name }}
        </a>
      </li>
      <li class="breadcrumb-item" aria-current="page" *ngIf="blogDetail?.subcatagory_id!=null && subCategoryData!=undefined && subCategoryData.length>0">
        <a (click)="openBlogViaSubCategory()">
          {{ subCategoryData[0]?.name?.length ?? 0 > 15 ? (subCategoryData[0]?.name | slice:0:15) : subCategoryData[0]?.name }}
        </a> 
      </li>
      <li class="breadcrumb-item" aria-current="page"><a>
          {{ blogDetail?.title?.length ?? 0 > 15 ? (blogDetail?.title | slice:0:15) + '...' : blogDetail?.title }}
        </a> 
      </li>
    </ul>
  </div>

  <!-- blog-filter-panel END -->
    <div class="border-size mb-4">
        <div class="blog-bg-white">
            <section class="individua-blog-section" *ngIf="blogDetail">
                <div class="row align-items-end">
                    <div class="col-lg-8 col-12">
                        <span class="skincare-type">{{blogDetail?.category?.name}}</span>
                        <h1>{{blogDetail?.title}}</h1>
                        <h2 class="sub-cetegaris-heading">{{blogDetail?.short_description}}</h2>
                        <div class="skin-exper mt-3">
                            <h3>By {{blogDetail?.author_name}}</h3>
                        </div>
                    </div>
                    <div class="col-lg-4 col-12 mt-4">
                        <div class="right-section">
                            <div class="share-text order-lg-2 order-1">
                                <span>share</span>
                                <div class="share-icon">
                                    <a [href]="'https://twitter.com/intent/tweet?url=' + currentUrl" target="_blank"><img src="assets/images/new-twitter.svg" alt="icon"></a>
                                    <a [href]="'https://web.whatsapp.com/send?text=' + currentUrl" target="_blank" data-action="share/whatsapp/share"><img src="assets/images/b-whatsapp-icon.png" alt="icon"></a>
                                    <a [href]="'https://pinterest.com/pin/create/button/?url=' + currentUrl" target="_blank"><img src="assets/images/b-pintrest-icon.png" alt="icon"></a>
                                    <a [href]="'https://www.facebook.com/sharer/sharer.php?u=' + facebookUrl" target="_blank"><img src="assets/images/fb-icon.svg" alt="icon"></a>
                                </div>
                              
                            </div>
                       </div>
                    </div>
                    <div class="col-12">
                        <div class="inner-banner-img">
                            <img [src]="getBlogThumbnail(this.blogDetail?.imageList, 'blog_banner_image')" alt="image">
                        </div>
                    </div>
                </div>
            </section>
            <section class="individual-blog" *ngIf="blogDetail">
              <div class="row justify-content-between">
                <div class="col-lg-7 col-12">
                  <div class="i-b-content">
                    <p [innerHTML]="blogDetail?.description"></p>
                    
                    <div class="t-img-v d-v-none row">
                      <div class="col-12 px-0">
                        <span class="blog-l-image" *ngIf="getBlogThumbnail(blogDetail?.imageList, 'blog_image_1') !== ''">
                          <img [src]="blogDetail && getBlogThumbnail(blogDetail?.imageList, 'blog_image_1')" alt="image">
                        </span>
                      </div>
                      <div class="col-12 px-0 img-margin" *ngIf="getBlogThumbnail(blogDetail?.imageList, 'blog_image_2') !== ''">
                        <span class="blog-r-image">
                          <img [src]="blogDetail && getBlogThumbnail(blogDetail?.imageList, 'blog_image_2')" alt="image">
                        </span>
                      </div>
                    </div>
                    
                    <p [innerHTML]="blogDetail?.description2"></p>
                    <div class="mt-5">
                      <p [innerHTML]="blogDetail?.description3"> </p>
                    </div>
                    <div class="share-text-blog">
                      <span>share</span>
                      <div class="share-icon">
                        <a [href]="'https://twitter.com/intent/tweet?url=' + currentUrl" target="_blank"><img src="assets/images/new-twitter.svg" alt="icon"></a>
                        <a [href]="'https://web.whatsapp.com/send?text=' + currentUrl" target="_blank" data-action="share/whatsapp/share"><img src="assets/images/b-whatsapp-icon.png" alt="icon"></a>
                        <a [href]="'https://pinterest.com/pin/create/button/?url=' + currentUrl" target="_blank"><img src="assets/images/b-pintrest-icon.png" alt="icon"></a>
                        <a [href]="'https://www.facebook.com/sharer/sharer.php?u=' + facebookUrl" target="_blank"><img src="assets/images/fb-icon.svg" alt="icon">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-5">
                  <div class="i-b-image t-v-none" *ngIf="getBlogThumbnail(blogDetail?.imageList, 'blog_image_1') !== ''">
                    <span><img [src]="blogDetail && getBlogThumbnail(blogDetail?.imageList, 'blog_image_1')" alt="image"></span>
                  </div>
                  <div class="i-b-image t-v-none" *ngIf="getBlogThumbnail(blogDetail?.imageList, 'blog_image_2') !== ''">
                    <span><img [src]="blogDetail && getBlogThumbnail(blogDetail?.imageList, 'blog_image_2')" alt="image"></span>
                  </div>
                  <div class="i-b-img d-lg-flex d-none" *ngIf="getBlogThumbnail(blogDetail?.imageList, 'blog_image_3') !== ''">
                    <span><img [src]="blogDetail && getBlogThumbnail(blogDetail?.imageList, 'blog_image_3')" alt="image"></span>
                  </div>
                </div>
              </div>
              <div class="col-12 border-top d-none"></div>
            </section>
            <!-- blog section start -->
            <section class="blog-section i-blog-section d-none">
              <div class="section-title text-center">
                <h3>Trending  BLOGS</h3>
              </div>
              <div class="mt-lg-4">
                <owl-carousel-o [options]="blogSlider" *ngIf="trendingBlogs && trendingBlogs.length > 0">
                    <ng-template carouselSlide *ngFor="let trendingBlog of trendingBlogs; let i = index">
                    <div class="s-blog-detail">
                        <span><img [src]="trendingBlog && getBlogThumbnail(trendingBlog.imageList,'blog_thumbnail_image')" alt="image" /></span>
                        <div class="b-title">{{trendingBlog?.name}}</div>
                        <small>{{trendingBlog?.short_description}}</small>
                    </div>
                    </ng-template>
                </owl-carousel-o>
                </div>
            </section>

            <!--Scroll to top-->
        </div>
    </div>
  <!-- blog section end -->

  <section class="blog-section-new" *ngIf="blogDetail?.ingredients && blogDetail.ingredients.length>0">
        <div class="blog-detail-tags" >
            <h5>Blog Tags</h5>
            <ul class="none-scrollbar">
                <li *ngFor="let cat of jsonData; let i = index" (click)="openBlogList(cat?.id)"><a [ngStyle]="cat?.color && cat?.color == '#fff' ? {'background': cat?.color , 'color' : '#000'} : cat?.color  ? {'background': cat?.color , 'color' : '#fff'} : {'background': '#d3d3d3' , 'color' : '#000'} " class="c-orange">{{cat?.name}}</a></li>
            </ul>
        </div>
  </section>

  <section class="trending-Main i-u-blog-section">
    <div class="heading-title">
      <div class="heading ">
          <h4>BLOGS<span>Trending</span></h4>
        </div>
    </div>
    <div class="trending-d">
      <div class="row trending-d-scroll scrollbar-width-none w-100" *ngIf="newtrendingBlogs && newtrendingBlogs.length > 0">
          <div class="col-lg-4 col-sm-6 col-12" *ngFor="let trendingBlog of newtrendingBlogs; let i = index">
              <app-blogs  [categoryList]="mCategoryResponseModal?.data" [blog]="trendingBlog"></app-blogs>
          </div>
      </div>
    </div>
    <div class="view-all bg-c-change">
      <a class="cta-button outline-btn-light  bg-c-b cta-button-new" (click)="showAllTrending()">View all</a>
   </div>
  </section>
  <button
  *ngIf="showButton"
  id="backToTopBtn"
  title="Go to top"
  (click)="scrollToTop()"
>
<i class="fa-solid fa-chevron-up" style="color: #ffffff;"></i>
</button>

</div>
<!-- footer section start  -->
  <app-footer-bg></app-footer-bg>
  <!-- footer section End  -->